import liveChatVisibleUrls from '@constants/live-chat-visible-urls';
export var findLiveChatVisibleUrl = function (pathname) {
    return liveChatVisibleUrls.find(function (url) { return pathname.indexOf(url) >= 0; });
};
